import {
    GET_TREATMENT_NOTES
} from '../actions/types';

/**
 * Initial state
 */
const INIT_STATE = {
    list: {
        items: [],
        pagination: {
            currentPage: 1,
            total: 0,
            perPage: 30
        }
    }
};

export default (state = INIT_STATE, action) => {
    switch (action.type) {
        case GET_TREATMENT_NOTES: {
            return {
                ...state,
                list: {
                    items: action.payload?.data || [],
                    pagination: {
                        currentPage: parseInt(action.payload.current_page),
                        total: parseInt(action.payload.total),
                        perPage: parseInt(action.payload.per_page),
                    }
                }
            };
        }
        default:
            return { ...state };
    }
};
